<template>
  <qx-card-form title="自动打款与付款账户">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
      v-if="baseForm.form.length !== 0"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      originData: [],
      baseForm: {
        form: [
          // {
          //   label: '客户编码',
          //   value: 'customerCode',
          //   type: 'input',
          // },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async sub () {
      const data = await this.cacheData();
      const result = {};
      data.account.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          result[`payFeeLimitSecCfgs_3_${index}.${key}`] = item[key];
        });
      });
      result['secNumArray_3'] = this.originData.length;
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      this.originData.forEach((item, index) => {
        item.valueBig = res[String(index)];
      });
      return {
        account: this.originData,
      };
    },
    async init (data = {}) {
      this.originData = data.account;
      this.renderForm();
    },
    renderForm () {
      this.baseForm.form = [];
      this.originData.forEach((item, index) => {
        let remark = '';
        switch (index) {
          case 0:
            remark = '如果设置成是，则只要公司平台账户有钱，系统会自动完成支付；如果设置成否，则需要在公司支付功能中进行打款操作。';
            break;
          case 1:
            remark = '支付自有车运费时，默认使用的公司账户类型。';
            break;
          case 2:
            remark = '支付司机工资时，默认使用的公司账户类型。';
            break;
          case 3:
            remark = '支付其他费用时，如借支、报销等，默认使用的公司账户类型。';
            break;
          case 4:
            remark = '司机使用虚拟油到要求现付的油站加油时，为保证油站能够及时收到加油资金，请确保账户有充足的资金，系统将自动打款给油站。';
            break;
          case 5:
            remark = '如果设置成是，则在公司支付时，需要输入支付密码；如果设置成否，则在公司支付时，无需输入支付密码。';
            break;
          case 6:
            remark = '如果设置成是，则在车辆档案中进行北斗缴费时，系统自动支付；如果设置成否，则在车辆档案中进行北斗缴费时，需要在公司支付功能中进行打款操作。';
            break;
          default:
            break;
        }
        if (index === 1 || index === 2 || index === 3) {
          this.baseForm.form.push({
            label: item.subTypeName,
            value: String(index),
            type: 'select',
            unit: item.unitName,
            default: item.value,
            remark,
            options: [
              {
                label: '对公账户付款',
                value: 1,
              },
              {
                label: '私人账户付款',
                value: 0,
              },
            ],
          });
        } else {
          this.baseForm.form.push({
            label: item.subTypeName,
            value: String(index),
            type: 'radio',
            unit: item.unitName,
            default: item.value,
            remark,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
